import React from 'react'

import './time-input.scss'

const makeSureNDigits = digitsCount => number => {
  if (typeof number !== 'number')
    throw new TypeError('makeSureNDigits expects a number input')

  const numberString = number.toString()

  if (numberString.length < digitsCount) {
    return '0' + numberString
  }

  return numberString
}

const makeSure2Digits = makeSureNDigits(2)

const hours = Array(24)
  .fill()
  .map((_, index) => makeSure2Digits(index))

const minutes = Array(60)
  .fill()
  .map((_, index) => makeSure2Digits(index))

export default class TimeInput extends React.Component {
  state = {
    hourValue: '00',
    minuteValue: '00'
  }

  componentDidMount() {
    if (!this.props.initialValue) return

    const [hourValue, minuteValue] = this.props.initialValue.split(':')

    this.setState({
      hourValue: makeSure2Digits(hourValue),
      minuteValue: makeSure2Digits(minuteValue)
    })
  }

  componentDidUpdate(prevProps) {
    if (
      prevProps.selectedHour !== this.props.selectedHour ||
      prevProps.selectedMinute !== this.props.selectedMinute
    ) {
      this.setState({
        hourValue: makeSure2Digits(this.props.selectedHour),
        minuteValue: makeSure2Digits(this.props.selectedMinute)
      })
    }
  }

  onHourChange = event => {
    const hour = event.target.value
    this.setHour(hour)
  }

  setHour = hour => {
    this.setState(
      {
        hourValue: hour,
        minuteValue: '00' // minute should be reset too
      },
      () => this.props.onChange(this.format(hour, '00'))
    )
  }

  onMinuteChange = event => {
    const minutes = event.target.value
    this.setMinute(minutes)
  }

  setMinute = minutes => {
    this.setState(
      {
        minuteValue: minutes
      },
      () => this.props.onChange(this.format(this.state.hourValue, minutes))
    )
  }

  format = (hour, minute) => `${hour}:${minute}`

  render() {
    const { formatter = o => o, title = 'ساعت' } = this.props

    return (
      <section className="time-input">
        <div className="time-input__title">{title}</div>

        <select
          onChange={this.onMinuteChange}
          value={this.state.minuteValue}
          className="time-input__minute-input"
        >
          {minutes.map(minute => (
            <option key={minute} value={minute}>
              {formatter(minute)}
            </option>
          ))}
        </select>

        <section className="time-input__colon">:</section>

        <select
          onChange={this.onHourChange}
          value={this.state.hourValue}
          className="time-input__hour-input"
        >
          {hours.map(hour => (
            <option key={hour} value={hour}>
              {formatter(hour)}
            </option>
          ))}
        </select>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/common/FormFields/TimeInput/TimeInput.js